import { zeroWidthNonBreakingSpace } from '@upright/ui/common/generic/utilities/zero-width-space';
import { ModalInfoBoxWrap } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/info-boxes/modal-info-box-wrap';
import { commonInfoBoxBorder } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/info-boxes/styles';
import { LensBoxMode } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/types';
import { useCarouselLayout } from '@upright/ui/common/upright/core/impact-lens-profile/context';
import { ReactNode, CSSProperties } from 'react';
import styled from 'styled-components';

export interface Props {
  x: number;
  width: number;
  height: number;
  minHeight?: number;
  y: number;
  children?: ReactNode;
  topColor?: string;
}

export function GenericStaticallySizedInfoBox(props: Props) {
  const layout = useCarouselLayout();

  if (layout.boxMode === LensBoxMode.MODAL) {
    return (
      <ModalInfoBoxWrap maxWidth={props.width}>
        <Main>
          {props.topColor ? (
            <ColorBlock style={{ backgroundColor: props.topColor }}>{zeroWidthNonBreakingSpace}</ColorBlock>
          ) : undefined}
          {props.children}
        </Main>
      </ModalInfoBoxWrap>
    );
  } else {
    const style: CSSProperties = {
      position: 'absolute',
      top: props.y,
      height: props.height,
      left: props.x,
      width: props.width,
    };
    return (
      <Root style={style}>
        <Main>
          {props.topColor ? (
            <ColorBlock style={{ backgroundColor: props.topColor }}>{zeroWidthNonBreakingSpace}</ColorBlock>
          ) : undefined}
          {props.children}
        </Main>
      </Root>
    );
  }
}

const Root = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
`;

const Main = styled.div`
  ${commonInfoBoxBorder};
  background-color: white;
  width: 100%;
  height: 100%;
  font-size: 12px;
  line-height: 128.8%;
`;

const ColorBlock = styled.div`
  height: 2px;
`;
